import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5fa2d137"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-product-info-groups"
};
const _hoisted_2 = {
  class: "product-group-cell"
};
const _hoisted_3 = {
  class: "product-group-info"
};
const _hoisted_4 = {
  class: "product-group-inner"
};
const _hoisted_5 = ["id"];
const _hoisted_6 = {
  class: "product-group-details"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "product-group-image",
    style: _normalizeStyle({
      backgroundImage: `url(${$props.image})`
    })
  }, null, 4), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "product-group-name ba-text ba-text-left",
    id: $props.item_id
  }, _toDisplayString($props.name), 9, _hoisted_5), $props.item_id ? (_openBlock(), _createBlock(_component_app_popover, {
    key: 0,
    target: $props.item_id,
    "auto-width": "",
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($props.name), 1)]),
    _: 1
  }, 8, ["target"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "details", {}, undefined, true)])])]), _renderSlot(_ctx.$slots, "badge", {}, undefined, true)])]);
}